import React, { useEffect, useState } from "react";
import { TextField, Button, Box, Typography } from "@mui/material";
import { LocalizationProvider } from "@mui/x-date-pickers";
import { DatePicker } from "@mui/x-date-pickers";
import dayjs from "dayjs";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { useTheme, useMediaQuery, Switch } from "@mui/material";
import GoalItem from "./GoalItem";
import axiosInstance from "../../components/AxiosInstance"; // Use axios instance
import useSharedLink from "../../scenes/SharedLink";
import { useNavigate } from "react-router-dom";
import LoadingIndicator from "../../scenes/Loader";
import { getColorForGoalState } from "../../constants";
const GoalDataManager = ({
  client,
  nodes,
  clientId,
  clientName,
  sessionId,
  owner,
  handleSwitchChange,
  switchChecked,
  goalSelected,
  dateSelected = null,
}) => {
  const [goals, setGoals] = useState([]);
  const [selectedGoal, setSelectedGoal] = useState();
  const [selectedDate, setSelectedDate] = useState(
    dateSelected ? dayjs(dateSelected) : dayjs()
  );
  console.log("dateselected", selectedDate, "nodes", nodes);
  const [lastSelectedGoalId, setLastSelectedGoalId] = useState(null);
  const [lastSelectedDate, setLastSelectedDate] = useState(dateSelected);
  const [filteredGoals, setFilteredGoals] = useState([]);
  const [highlightedGoals, setHighlightedGoals] = useState([]);
  const [activeFilter, setActiveFilter] = useState("All");
  const [loading, setLoading] = useState(true);
  const theme = useTheme();
  const sharedLink = useSharedLink();
  const navigate = useNavigate();
  const isSmallScreen = useMediaQuery(theme.breakpoints.down("sm"));

  useEffect(() => {
    const filteredNodes = nodes.filter(
      (goal) => goal.programType !== "Frequency"
    );
    setGoals(filteredNodes);

    // Update only if `goalSelected` or `dateSelected` actually changed
    if (
      goalSelected !== lastSelectedGoalId ||
      dayjs(dateSelected).isValid() !== dayjs(lastSelectedDate).isValid()
    ) {
      const newSelectedGoal = filteredNodes.find(
        (node) => node.goalId + "" === "" + goalSelected
      );

      if (newSelectedGoal) {
        setSelectedGoal(newSelectedGoal);
      }
      if (dateSelected) {
        setSelectedDate(dayjs(dateSelected));
      }

      // Update the last selected goal and date
      setLastSelectedGoalId(goalSelected);
      setLastSelectedDate(dateSelected);
    }

    // Only set an initial goal if no goal is selected already
    if (!selectedGoal && !goalSelected) {
      const initialSelectedGoal = filteredNodes[0] || null;
      setSelectedGoal(initialSelectedGoal);
    }
    console.log("goalselected", selectedGoal, goalSelected, lastSelectedGoalId);
    setFilteredGoals(filteredNodes);
  }, [nodes, goalSelected, dateSelected]); // Dependency array remains the same

  const handleGoalClick = (goal) => {
    setSelectedGoal(goal);
  };

  const handleGoalSave = (savedGoal) => {
    // Set the selected goal to the saved goal to ensure it stays visible
    setSelectedGoal(savedGoal);

    // Highlight the saved goal
    setHighlightedGoals((prev) => {
      if (!prev.some((goal) => goal.goalId + "" === "" + savedGoal.goalId)) {
        return [...prev, savedGoal];
      }
      return prev; // Goal is already highlighted
    });
  };

  //   setLoading(true);
  //   try {
  //     const response = await axiosInstance.get(`${sharedLink}/getprogrambooks`);
  //     if (response.status === 200) {
  //       const extractedGoals = extractGoalsFromResponse(response.data);
  //       setGoals(extractedGoals);
  //       setFilteredGoals(extractedGoals);
  //     }
  //   } catch (error) {
  //     console.error("Failed to fetch initial goals:", error);
  //   } finally {
  //     setLoading(false);
  //   }
  // };

  // // Extract goals from the nested response structure
  // const extractGoalsFromResponse = (data) => {
  //   const goals = [];
  //   data.forEach((book) => {
  //     book.dataStrategyList?.forEach((strategy) => {
  //       strategy.developmentalAreaList?.forEach((area) => {
  //         area.treatmentPlanObjectiveList?.forEach((objective) => {
  //           objective.shortTermObjective?.forEach((shortTerm) => {
  //             if (shortTerm.goals) {
  //               shortTerm.goals.forEach((goal) => {
  //                 if (goal.programType !== "Frequency") {
  //                   goals.push({
  //                     goalId: goal.id,
  //                     goalName: goal.goalName,
  //                     programType: goal.programType,
  //                     goalDescription: goal.goalDescription,
  //                     nullExists: goal.nullExists,
  //                   });
  //                 }
  //               });
  //             }
  //           });
  //         });
  //       });
  //     });
  //   });
  //   return goals;
  // };
  const fetchRawData = async (date) => {
    try {
      const payload = {
        clientId: clientId,
        sessionDate: dayjs(date).format("YYYY-MM-DD"),
      };

      const response = await axiosInstance.post(
        `${sharedLink}/getRawDataColor`,
        payload
      );

      if (response.status === 200) {
        // const {
        //   percentageData = [],
        //   taskAnalysisData = [],
        //   durationData = [],
        // } = response.data;

        // Extract goal IDs to highlight
        const goalIdsToHighlight = [
          ...(response.data.percentageData || []),
          ...(response.data.taskAnalysisData || []),
          ...(response.data.durationData || []),
        ];

        setHighlightedGoals(goalIdsToHighlight); // Store the goal IDs to
      }
    } catch (error) {
      console.error("Failed to fetch raw data:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchRawData(selectedDate); // Automatically fetch raw data on component mount
  }, []); // Empty dependency array ensures this runs only once

  // useEffect(() => {
  //   // Fetch goals initially from getprogrambooks API
  //   fetchInitialGoals();
  // }, []);

  // Handle date changes and fetch data for the selected date
  const handleDateChange = (newValue) => {
    setSelectedDate(newValue);
    fetchRawData(newValue); // Fetch data for the newly selected date
  };

  const handleSearch = (event) => {
    const searchTerm = event.target.value?.toLowerCase();
    if (searchTerm === "") {
      handleFilter(activeFilter);
    } else {
      const filtered = goals.filter(
        (goal) =>
          goal?.goalName?.toLowerCase().includes(searchTerm) &&
          (activeFilter === "All" || goal.programType === activeFilter)
      );
      setFilteredGoals(filtered);
    }
  };

  const handleFilter = (type) => {
    console.log(goals, " type ", type);
    setActiveFilter(type);
    if (type === "All") {
      setFilteredGoals(goals);
    } else {
      const filtered = goals.filter((goal) => {
        if (type === "TaskAnalysis") {
          return goal.programType === "Task Analysis"; // Match the exact program type
        }
        return goal.programType === type;
      });
      setFilteredGoals(filtered);
    }
  };
  if (loading) return <LoadingIndicator />;
  return (
    <LocalizationProvider dateAdapter={AdapterDayjs}>
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          width: "100%",
          height: "100vh",
        }}>
        {/* Header with Date Picker */}
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            padding: 2,
            borderBottom: "1px solid #ddd",
            position: "sticky",
            top: 0,
            backgroundColor: "white",
            zIndex: 1000,
          }}>
          <Box sx={{ display: "flex", alignItems: "center" }}>
            <Switch checked={switchChecked} onChange={handleSwitchChange} />
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                marginLeft: 2, // Space between Switch and Avatar/Name
              }}>
              <Typography
                sx={{
                  marginRight: 1,
                  fontSize: "1.5rem", // Adjust emoji size
                }}>
                {client.gender === "Male"
                  ? "👨" // Male emoji
                  : client.gender === "Female"
                  ? "👩" // Female emoji
                  : ""}
              </Typography>
              <Typography
                variant="h6"
                sx={{
                  fontWeight: "bold",
                  textTransform: "capitalize", // Capitalize name
                }}>
                {clientName}
              </Typography>
            </Box>
          </Box>
          <DatePicker
            label="Select Date"
            value={
              dayjs(selectedDate).isValid() ? dayjs(selectedDate) : dayjs()
            } // Fallback to current date if invalid
            onChange={handleDateChange}
            disableFuture
            sx={{ width: "250px" }}
          />
        </Box>

        {/* Main Content Area */}
        <Box
          sx={{
            display: "flex",
            flexGrow: 1,
            height: "calc(100vh - 128px)",
            overflow: "hidden",
          }}
          // onMouseDown={(e) => e.preventDefault()} // Prevent text selection during resizing
        >
          {/* Left Sidebar */}
          <Box
            sx={{
              width: isSmallScreen ? "100%" : "30%",
              minWidth: isSmallScreen ? "100%" : "20%", // Set a minimum width
              maxWidth: "40%", // Set a maximum width
              overflow: "auto", // Enable scrolling if content overflows
              borderRight: "1px solid #ddd",
              padding: 2,
              position: "relative",
              resize: "horizontal", // Allow full-height resizing
            }}>
            {/* Hover indicator for resizing */}
            <Box
              sx={{
                position: "absolute",
                top: 0,
                right: 0,
                width: "5px",
                height: "100%",
                cursor: "ew-resize",
                backgroundColor: "transparent",
                zIndex: 10,
                "&:hover": {
                  backgroundColor: "rgba(0, 0, 0, 0.1)",
                },
              }}
              onMouseDown={(e) => {
                const sidebar = e.currentTarget.parentElement;
                const initialWidth = sidebar.offsetWidth;
                const startX = e.clientX;

                const onMouseMove = (moveEvent) => {
                  const newWidth = initialWidth + (moveEvent.clientX - startX);
                  if (newWidth >= 200 && newWidth <= 600) {
                    sidebar.style.width = `${newWidth}px`;
                  }
                };

                const onMouseUp = () => {
                  document.removeEventListener("mousemove", onMouseMove);
                  document.removeEventListener("mouseup", onMouseUp);
                };

                document.addEventListener("mousemove", onMouseMove);
                document.addEventListener("mouseup", onMouseUp);
              }}
            />
            <TextField
              placeholder="Search Goals"
              variant="outlined"
              fullWidth
              onChange={handleSearch}
              sx={{ mb: 2 }}
            />
            {filteredGoals.map((goal) => {
              const highlightedGoal = highlightedGoals.find(
                (highlight) => highlight.goalId === goal.goalId
              );
              const goalState = highlightedGoal
                ? highlightedGoal.goalState
                : goal.goalState
                ? goal.goalState
                : "Baseline";
              console.log("highlightedGoal", highlightedGoal);

              return (
                <Box
                  key={goal.goalId}
                  sx={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    padding: 1,
                    marginBottom: 1,
                    border: "1px solid #ddd",
                    borderRadius: 2,
                    cursor: "pointer",
                    backgroundColor:
                      highlightedGoal && highlightedGoal?.nullExists === false
                        ? "#d0f0c0" // Light green background for highlighted goals
                        : selectedGoal && selectedGoal.goalId === goal.goalId
                        ? "skyblue" // Sky-blue background for the selected goal
                        : "#fff",
                  }}
                  title={goal.goalName}
                  onClick={() =>
                    handleGoalClick({ ...goal, goalState: goalState })
                  }>
                  <Typography
                    variant="body1"
                    sx={{
                      fontWeight: "bold",
                      whiteSpace: "normal", // Allow wrapping for long text
                      overflowWrap: "break-word",
                      wordWrap: "break-word",
                      overflow: "hidden",
                      textOverflow: "ellipsis",
                    }}>
                    {goal.goalName}
                  </Typography>

                  <Typography
                    variant="body1"
                    sx={{
                      fontWeight: "bold",
                      color: goalState
                        ? getColorForGoalState(goalState)
                        : "#000",
                    }}>
                    {goalState}
                  </Typography>
                </Box>
              );
            })}
          </Box>

          {/* Right Content Area */}
          <Box
            sx={{
              flexGrow: 1,
              padding: 3,
              overflowY: "auto",
              height: "100%",
            }}>
            {selectedGoal && selectedDate ? (
              <GoalItem
                key={`${selectedGoal?.goalId}-${selectedDate?.format(
                  "YYYY-MM-DD"
                )}`}
                goal={selectedGoal}
                client={client}
                goals={nodes}
                sessionId={sessionId}
                clientId={clientId}
                sessionDate={selectedDate}
                clientName={clientName}
                owner={owner}
                onSaveGoal={handleGoalSave}
                highlightedGoals={highlightedGoals} // Pass highlighted goals
                setHighlightedGoals={setHighlightedGoals} // Pass setter function
              />
            ) : (
              <Typography variant="h5" sx={{ textAlign: "center" }}>
                Select a Goal to View Details
              </Typography>
            )}
          </Box>
        </Box>

        {/* Footer */}
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-around",
            padding: 2,
            borderTop: "1px solid #ddd",
            backgroundColor: "#f9f9f9",
            position: "sticky",
            bottom: 0,
          }}>
          {["All", "Percentage", "Duration", "TaskAnalysis"].map(
            (filterType) => (
              <Button
                key={filterType}
                variant="contained"
                onClick={() => handleFilter(filterType)}
                sx={{
                  backgroundColor:
                    activeFilter === filterType ? "yellow" : "blue",
                  color: activeFilter === filterType ? "blue" : "white",
                  borderRadius: "20px", // Rounded corners
                  "&:hover": {
                    backgroundColor:
                      activeFilter === filterType ? "yellow" : "darkblue", // Change hover color
                  },
                }}>
                {filterType.toUpperCase()}
              </Button>
            )
          )}
          <Button
            variant="contained"
            onClick={() => navigate(-1)}
            color="primary"
            sx={{
              borderRadius: "20px", // Rounded corners
              backgroundColor: "blue",
              color: "white",
              "&:hover": {
                backgroundColor: "darkblue",
              },
            }}>
            Go Back
          </Button>
        </Box>
      </Box>
    </LocalizationProvider>
  );
};

export default GoalDataManager;

// Usage Example:
// const goals = [
//   { id: 1, label: "Sit Down [Percentage]", description: "Description of Sit Down.", programType: "Percentage" },
//   { id: 2, label: "Stand Up [Frequency]", description: "Description of Stand Up.", programType: "Frequency" },
// ];
// <GoalDataManager goals={goals} />
